import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button } from '@mui/material'

import Modal from './Modal'

export default function InvalidTextModal({ open, error, onClose }) {
  return (
    <Modal
      title="Please fill your titles"
      open={open}
      onClose={onClose}
    >
      <Box px={3} textAlign="center">
        <p>
          { error }
        </p>
      </Box>
      <Box display="flex" justifyContent="center" px={3} py={2}>
        <Button
          variant="contained"
          onClick={onClose}
        >
          OK
        </Button>
      </Box>
    </Modal>
  )
}

InvalidTextModal.propTypes = {
  open: PropTypes.bool,
  error: PropTypes.string,
  onClose: PropTypes.func,
}
